// primary colors
$primary-blue: #4a90e2;
$primary-green: #37c273;
$primary-grey: #505050;
$primary-yellow: rgb(237, 201, 73);
$primary-brown: rgb(156, 117, 95);
$primary-white: #fff;

$secondary-blue: rgb(78, 121, 167);
$secondary-yellow: rgb(242, 142, 44);
$secondary-red: rgb(225, 87, 89);
$secondary-green: rgb(118, 183, 178);

$blue-highlight: #5b9fee;
$green-highlight: #66ff00;

// Mot colors
$mot-air: $secondary-blue;
$mot-sea: $secondary-green;
$mot-rail: $secondary-red;
$mot-road: $secondary-yellow;

$label-color: $primary-white;
$primary-font-family: 'Roboto, sans-serif';

:export {
    primaryBlue: $primary-blue;
    primaryGreen: $primary-green;
    primaryGrey: $primary-grey;
    primaryYellow: $primary-yellow;
    primaryBrown: $primary-brown;
    secondaryBlue: $secondary-blue;
    secondaryYellow: $secondary-yellow;
    secondaryRed: $secondary-red;
    secondaryGreen: $secondary-green;
    blueHighlight: $blue-highlight;
    greenHighlight: $green-highlight;
    labelColor: $label-color;

    graphBarColorGreen: $primary-green;
    graphBarColorYellow: $primary-yellow;
    graphBarColorRed: $secondary-red;
    graphBarColorPrimary: $primary-blue;
    graphBarColorGrey: $primary-grey;
    motAir: $mot-air;
    motSea: $mot-sea;
    motRail: $mot-rail;
    motRoad: $mot-road;
}

$graph-text-color: $primary-white;
$graph-node-color: $primary-blue;

.graph-xy-axis-labels {
    font-family: $primary-font-family;
    font-size: 1.5em;
    fill: $label-color;
}

.graph-xy-tick-labels {
    font-family: $primary-font-family;
    font-size: 1.2em;
}

.graph-bar-labels {
    font-family: $primary-font-family;
    font-size: 1em;
    fill: $label-color;
}

.graph-legend-labels {
    font-family: $primary-font-family;
    font-size: 1.2em;
    fill: $label-color;
}
